module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-google-recaptcha/~/babel-runtime/core-js/get-iterator.js
 ** module id = 2827
 ** module chunks = 0
 **/